import { render } from "./EvaluationUserTestsView.vue?vue&type=template&id=2f5c8d6c"
import script from "./EvaluationUserTestsView.vue?vue&type=script&lang=js"
export * from "./EvaluationUserTestsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__